'use strict';

exports = module.exports = {
  // List of user roles
  userRoles: ['guest', 'user', 'admin']
};



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/shared.js
// module id = 19
// module chunks = 0